module.exports = __webpack_public_path__ + "img/arrow-left.4dc7144b.svg";